import { raise } from '@vy/utils';
import { createContext, useContext } from 'react';
import type { PlanCreationPlanPreview } from '../../../../../contexts/create-plan-context/CreatePlanProvider/create-plan-provider-types/plan-creation-plan-preview';

export type CreateCreditNoteContextProps = {
  planPreview: PlanCreationPlanPreview;
};

export const CreateCreditNoteContext = createContext<CreateCreditNoteContextProps | undefined>(undefined);

export function useCreateCreditNoteContext() {
  const createCreditNoteContext = useContext<CreateCreditNoteContextProps | undefined>(
    CreateCreditNoteContext,
  );

  if (!createCreditNoteContext) {
    raise('useCreateCreditNoteContext must be used within a CreateCreditNoteContextProvider');
  }

  return createCreditNoteContext;
}
